// frontend/src/components/ReviewsCertifications/ReviewsCertificationsReports/ReviewsCertificationsList.jsx
import React from "react";
import { CRUDFunction } from "../../../reduxCURD/container";
import ThisTable from "../../Common/ThisTable";
import SpinnerLoader from "../../Common/SpinnerLoader";
import { trackReportStyle } from "../../Reports/Timps/style";
import { themeService } from "../../../theme/service/activeTheme.service";
import { languageService } from "../../../Language/language.service";
import { SelectField } from "../../Reports/Timps/reportfilter";
import { dateSort } from "../../../utils/sortingMethods";
import moment from "moment";
import { Col } from "reactstrap";
import permissionCheck from "../../../utils/permissionCheck";

class ReviewsCertificationsList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      reviewTests: [],
      spinnerLoading: false,
      reportTypeOptions: [
        ...(permissionCheck("BLUECARD TEST", "submit_for_certification") ? [{ val: "inProgress", text: "Incomplete" }] : []),
        { val: "pending", text: "Pending" },
        { val: "certified", text: "Certified" },
      ],
    };

    this.groupTestsByTestCodeAndAssetId = this.groupTestsByTestCodeAndAssetId.bind(this);
    this.buildTableData = this.buildTableData.bind(this);
    this.handlePerformReview = this.handlePerformReview.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
  }

  componentDidMount() {
    // initialize from props.reportType if provided

    this.props.getReviewsCertifications(`pendingcertification?type=${this.props.reportType}`);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.actionType === "REVIEWSCERTIFICATIONS_READ_REQUEST" && this.props.actionType !== prevProps.actionType) {
      this.setState({ spinnerLoading: true });
    }
    if (this.props.actionType === "REVIEWSCERTIFICATIONS_READ_SUCCESS" && this.props.actionType !== prevProps.actionType) {
      this.setState({
        spinnerLoading: false,
        reviewTests: this.props.reviewsCertifications,
      });
    }
    if (this.props.actionType === "REVIEWSCERTIFICATIONS_READ_FAILURE" && this.props.actionType !== prevProps.actionType) {
      this.setState({ spinnerLoading: false });
    }
  }

  groupTestsByTestCodeAndAssetId(tests) {
    return tests.reduce((groups, test) => {
      const key = `${test.testCode}_${test.assetId}`;
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(test);
      return groups;
    }, {});
  }

  buildTableData(groupedTests) {
    return Object.keys(groupedTests).map((testCode) => {
      const tests = groupedTests[testCode];
      const lastTest = tests[tests.length - 1];
      return {
        testCode: lastTest.testCode, // include testCode for callback
        assetId: lastTest.assetId,
        action: "Perform Review",
        asset: lastTest.assetName || "",
        location: lastTest.lineName || "",
        submittedBy: lastTest.user && lastTest.user.name ? lastTest.user.name : "",
        submissionDate: lastTest.date ? new Date(lastTest.date) : "",
        testsPerformed: lastTest.title,
        otherInfo: lastTest.otherInfo,
        certifiedBy: (lastTest.otherInfo && lastTest.otherInfo.certifiedBy && lastTest.otherInfo.certifiedBy.name) || "",
        certifiedSubmissionDate: lastTest.otherInfo && lastTest.otherInfo.datePerformed ? new Date(lastTest.otherInfo.datePerformed) : "",
      };
    });
  }

  handlePerformReview(testCode, assetId) {
    // Instead of history.push, call parent callback:
    if (this.props.onViewReport) {
      this.props.onViewReport(testCode, assetId);
    } else {
      console.error("onViewReport callback not provided");
    }
  }

  changeHandler(e, isBlur) {
    if (e.target.name === "reportType") {
      this.props.onReportTypeChange(e.target.value);
      if (!isBlur) this.props.getReviewsCertifications(`pendingcertification?type=${e.target.value}`);
    }
  }

  render() {
    const { reviewTests, spinnerLoading, reportTypeOptions } = this.state;
    const { reportType } = this.props;
    const groupedTests = this.groupTestsByTestCodeAndAssetId(reviewTests);
    const tableData = this.buildTableData(groupedTests);

    const tableColumns = [
      {
        Header: "Action",
        accessor: "action",
        filterable: false,
        Cell: (cellProps) => {
          const orig = cellProps.row && cellProps.row._original;
          const testCode = orig ? orig.testCode : null;
          const assetId = orig ? orig.assetId : null;
          const otherInfo = orig ? orig.otherInfo : {};
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "75%",
              }}
            >
              <span
                onClick={() => {
                  if (testCode && assetId) {
                    this.handlePerformReview(testCode, assetId);
                  } else {
                    console.error("Test Code not found");
                  }
                }}
                style={{
                  textDecoration: "underline",
                  color: "blue",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
                onMouseEnter={(e) => (e.target.style.color = "darkblue")}
                onMouseLeave={(e) => (e.target.style.color = "blue")}
              >
                {reportType === "pending" ? "Perform Review" : reportType === "inProgress" ? "Submit for Certification" : "View"}
              </span>
            </div>
          );
        },
      },
      { Header: "Asset", accessor: "asset" },
      { Header: "Location", accessor: "location" },
      { Header: "Submitted By", accessor: "submittedBy" },
      ...(reportType === "certified" && [
        {
          Header: "Submission Date",
          id: "certifiedSubmissionDate",
          sortMethod: dateSort,
          accessor: (d) => (d.certifiedSubmissionDate ? moment(d.certifiedSubmissionDate).format("MM/DD/YYYY") : ""),
          Cell: (_props) => {
            const d = _props.row._original;
            return d.certifiedSubmissionDate ? moment(d.certifiedSubmissionDate).format("ddd, MMM D, YYYY") : "";
          },
        },
      ]),
      ...(reportType === "certified" && [{ Header: "Certified By", accessor: "certifiedBy" }]),
      {
        Header: reportType === "pending" || reportType === "inProgress" ? "Submission Date" : "Certified Date",
        id: "submissionDate",
        sortMethod: dateSort,
        accessor: (d) => (d.submissionDate ? moment(d.submissionDate).format("MM/DD/YYYY") : ""),
        Cell: (_props) => {
          const d = _props.row._original;
          return d.submissionDate ? moment(d.submissionDate).format("ddd, MMM D, YYYY") : "";
        },
      },
      {
        Header: "Test Performed",
        accessor: "testsPerformed",
        Cell: ({ value }) => <div style={{ whiteSpace: "pre-line", wordWrap: "break-word" }}>{value}</div>,
      },
    ];

    return (
      <div className="mainContent" style={{ textAlign: "center" }}>
        <Col md={12}>
          <div className="mainContent commonform" style={{ ...themeService(trackReportStyle.mainStyle), background: "transparent" }}>
            <h2
              style={{
                ...themeService(trackReportStyle.headingStyle),
                transform: "none",
                fontSize: "22px",
              }}
            >
              {languageService("Inspection Reports Certifications")}
            </h2>
            <br />
            <SelectField
              inputFieldProps={{ name: "reportType", label: "Type" }}
              options={reportTypeOptions}
              changeHandler={this.changeHandler}
              value={reportType}
            />
            <SpinnerLoader spinnerLoading={spinnerLoading} />{" "}
            {!spinnerLoading && (
              <ThisTable
                tableData={tableData}
                tableColumns={tableColumns}
                pagination={false}
                showFilters={true}
                minRows={1}
                dynamicRowHeight={true}
                dynamicRowHeightField="testsPerformed"
              />
            )}
          </div>
        </Col>
      </div>
    );
  }
}

let actionOptions = {
  create: false,
  update: false,
  read: true,
  delete: false,
  others: {},
};
const ReviewsCertificationsListContainer = CRUDFunction(
  ReviewsCertificationsList,
  "reviewsCertification",
  actionOptions,
  null,
  [],
  "testSchedule",
);
export default ReviewsCertificationsListContainer;



// WEBPACK FOOTER //
// ./src/components/ReviewsCertifications/TestsReviewCertification/TestsReviewCertificationList.jsx